import { Card, CardBody, Col } from "reactstrap";
import MobileEditButton from "../../../../../CommonElements/MobileEditButton";
import { P } from "../../../../../AbstractElements";
import BadgeDetails from "../../../../../CommonElements/Badge/BadgeDetails";
import {
  approvalLeaveModal,
  EndDate,
  infoColor,
  LeaveTypes,
  light,
  Reason,
  secondary,
  StartDate,
  Status,
  success,
  TotalDays,
  warningColor,
} from "../../../../../utils/Constant";
import { ModalType } from "../../../../../Types/UserProfileDetails";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { ILeaveData } from "../../types";
import { dateConversion } from "../../../../../utils/dateUtils";

export interface ITeamMembersLeaveRequestCardProps {
  teamMember: ILeaveData;
  openModal: (
    modalType: ModalType,
    employeeInfo: ILeaveData,
    leaveId: number
  ) => void;
}

const TeamMembersLeaveRequestCard = ({
  teamMember,
  openModal,
}: ITeamMembersLeaveRequestCardProps) => {
  const { darkMode } = useAppSelector(({ layout }) => layout);

  return (
    <Col xs="12" sm="6">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <P className="m-0 f-12">{teamMember.team_member.name}</P>
              <P className="m-0 f-12">{teamMember.team_member?.email}</P>
            </div>
            <MobileEditButton
              handleOnClick={() =>
                openModal(
                  approvalLeaveModal,
                  teamMember,
                  teamMember?.leave_id
                )
              }
            />
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex flex-column align-items-start">
              <BadgeDetails
                color={light}
                className={`badget-light f-12 ${
                  darkMode ? "text-white" : "text-dark"
                }`}
                badgeHeading={StartDate}
                text={teamMember.start_date}
              />
            </div>
            <div className="d-flex flex-column align-items-end">
              <BadgeDetails
                color={light}
                className={`badget-light f-12 ${
                  darkMode ? "text-white" : "text-dark"
                }`}
                badgeHeading={EndDate}
                text={teamMember.end_date}
              />
            </div>
          </div>
          {teamMember.against_compoff_date && (
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex flex-column align-items-start">
                <BadgeDetails
                  color={light}
                  className={`badget-light f-12 ${
                    darkMode ? "text-white" : "text-dark"
                  }`}
                  badgeHeading="Comp Off Date"
                  text={dateConversion(teamMember.against_compoff_date)}
                />
              </div>
            </div>
          )}
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex flex-column align-items-start">
              <BadgeDetails
                color={success}
                badgeHeading={LeaveTypes}
                text={teamMember.leave_type}
              />
            </div>
            <div className="d-flex flex-column align-items-end">
              <BadgeDetails
                color={warningColor}
                badgeHeading={TotalDays}
                text={teamMember.total_days.toString()}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex flex-column align-items-start">
              <BadgeDetails
                color={infoColor}
                badgeHeading={Status}
                text={teamMember.status}
              />
            </div>
            <div className="d-flex flex-column align-items-end">
              <BadgeDetails
                color={secondary}
                badgeHeading={Reason}
                text={teamMember.reason}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TeamMembersLeaveRequestCard;
